import {
  IconWarningCircle24Line as ExclamationCircleIcon,
  IconInfoCircle24Line as InformationCircleIcon,
  IconHelpCircle24Line as QuestionMarkCircleIcon,
} from "@wayflyer/flyui-icons/24/line";
import type { ModalProps, FlyIcon } from "@wayflyer/flyui";
import { Flex, Modal, Text, TextContainer, TextHeading, Icon as IconWrapper } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

type Variant = "question" | "warning" | "info";

export interface ConfirmModalProps
  extends Pick<ModalProps, "children" | "isOpen" | "primaryAction" | "tertiaryAction"> {
  title: string;
  variant?: Variant;
}

const iconMap: Record<Variant, { icon: FlyIcon; props }> = {
  question: { icon: QuestionMarkCircleIcon, props: {} },
  warning: { icon: ExclamationCircleIcon, props: { color: "warning" } },
  info: { icon: InformationCircleIcon, props: { color: "info" } },
};

export const ConfirmModal = ({
  variant = "question",
  title,
  children,
  isOpen = false,
  primaryAction,
  tertiaryAction,
}: ConfirmModalProps) => {
  const intl = useIntl();
  const Icon = iconMap[variant].icon;
  const iconProps = iconMap[variant].props;

  return (
    <Modal
      title={null}
      primaryAction={{ content: "Yes", ...primaryAction }}
      tertiaryAction={{
        content: intl.formatMessage({ id: "shared-ui: Cancel", defaultMessage: "Cancel" }),
        ...tertiaryAction,
      }}
      isOpen={isOpen}
    >
      <Flex gap="3" wrap="nowrap" padding={["3", "0", "0"]}>
        <IconWrapper {...iconProps}>
          <Icon />
        </IconWrapper>
        <TextContainer spacing="2">
          <TextHeading>{title}</TextHeading>
          <Text>{children}</Text>
        </TextContainer>
      </Flex>
    </Modal>
  );
};
